<script setup lang="ts">
const { t } = useI18n()
const localePath = useLocalePath()
const year = new Date().getFullYear()

const links = computed(() => [
  { label: t('nav.contact'), to: '/legal/contact' },
  { label: t('nav.terms_of_service'), to: '/legal/terms' },
  { label: t('nav.privacy_policy'), to: '/legal/privacy' },
  { label: t('nav.delete_account'), to: '/account/delete-request' },
])
</script>

<template>
  <footer class="border-t border-default/60 bg-default/40 backdrop-blur">
    <div class="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-8 sm:flex-row lg:px-8">
      <div class="flex items-center gap-2.5">
        <img src="/images/logo.png" alt="logo" class="size-7">
        <span class="text-sm font-semibold">agency-saas</span>
        <span class="text-xs ui-text-subtle">© {{ year }}</span>
      </div>
      <nav class="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        <NuxtLink
          v-for="l in links"
          :key="l.to"
          :to="localePath(l.to)"
          class="text-xs ui-text-subtle transition-colors hover:text-primary"
        >
          {{ l.label }}
        </NuxtLink>
      </nav>
    </div>
  </footer>
</template>
